import React from "react";
import styles from "./Articles.module.scss";
import articles1 from "../../../../img/articles1.webp";
import articles2 from "../../../../img/articles2.webp";
import { useTranslation } from "react-i18next";
const Articles = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.articles}>
      <div className="container">
        <div className={styles.articles__inner}>
          <article className={styles.article}>
            <h3 className={styles.desktop}>
              {t("Bundestag passes cannabis law")}
            </h3>
            <h3 className={styles.mobile}>{t("Cannabis law passed")}</h3>
            <div className={styles.article__body}>
              <picture>
                <source srcSet={articles1} type="image/webp" />
                <img src={articles1} alt="Germany legalizes cannabis" />
              </picture>

              <p className={styles.desktop}>
                {t(
                  "The Bundestag has voted in favor of the Cannabis Act by a large majority."
                )}{" "}
                <b>{t("The law came into force on April 1.")}</b>{" "}
                {t(
                  "From July, cannabis clubs can apply for a license and become active."
                )}
              </p>
              <p className={styles.mobile}>
                {t(
                  "The Bundestag has voted in favor of the Cannabis Act by a large majority."
                )}{" "}
                <b>{t("The law came into force on April 1.")}</b>{" "}
                {t(
                  "From July, cannabis clubs can apply for a license and become active."
                )}
              </p>
            </div>
          </article>
          <article className={styles.article}>
            <h3 className={styles.desktop}>
              {t("Deutsche Anbaugesellschaft at the DKM")}
            </h3>
            <h3 className={styles.mobile}>
              {t("Exhibition stand at the DKM")}
            </h3>
            <div className={styles.article__body}>
              <picture>
                <source srcSet={articles2} type="image/webp" />
                <img
                  src={articles2}
                  alt="Deutsche Anbaugesellschaft at the DKM"
                />
              </picture>
              <p>
                {t("Deutsche Anbaugesellschaft DAG presented itself at")}{" "}
                <b>{t("DKM 2023")}</b>
                {t(
                  ", the leading trade fair for the finance and insurance industry, with a stand in Hall 3. With almost 14,000 trade visitors and 285 exhibitors, DKM is one of the most significant trade fairs in the industry."
                )}
              </p>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
};

export default Articles;
